import { Box, styled } from '@mui/material';
import { FC } from 'react';

import { StoreSelection } from '../StoreSelection/StoreSelection';

export const Frontpage: FC = () => {
    return (
        <FrontPageWrapper>
            <Box style={{ width: '100%', flexGrow: 1 }}>
                <StoreSelection />
            </Box>
        </FrontPageWrapper>
    );
};

const FrontPageWrapper = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 1800,
    width: '100%',
    margin: '0 auto',
    flexGrow: 1,
}));
